export enum MemberErrors {
  OnlinePurchaseProhibitedForProductCode = "Online purchase only allowed for org with 43432 product code",
}
